<script>
  import { fetchProduct } from './utils'

  export let handle = null
  export let title = null
  export let config

  let BASE_URL = config.baseUrl
  let detailsText = config.gallery.detailsText

  $: maybeProductPromise = handle ? fetchProduct(handle) : null
  let priceFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
</script>

{#if maybeProductPromise}
  {#await maybeProductPromise then prod}
    {#if prod}
      <div class="grid__item grid-product small--one-half medium-up--one-quarter">
        <div class="grid-product__content">
          <a href={`${BASE_URL}${prod.url}`} class="grid-product__link">
            <div class="grid-product__image-mask">
              <div class="grid__image-ratio grid__image-ratio--square">
                <img
                  class="lazyautosizes lazyloaded"
                  data-aspectratio="1.0"
                  data-sizes="auto"
                  alt={prod.title}
                  src={prod.featured_image}
                />
              </div>

              {#if prod.images?.[1]}
                <div class="grid-product__secondary-image small--hide">
                  <img
                    class="lazyautosizes lazyloaded"
                    data-aspectratio="1.0"
                    data-sizes="auto"
                    alt={prod.title}
                    src={prod.images?.[1]}
                  />
                </div>
              {/if}
            </div>

            <div class="grid-product__meta">
              <div class="grid-product__title">
                {prod.title}
              </div>

              {#if prod.vendor}
              <div class="grid-product__vendor">{prod.vendor}</div>
              {/if}

              <div class="grid-product__price">
                <span>
                  {prod.price_varies ? 'From' : ''}
                  {window.theme?.Currency?.formatMoney(prod.price) ||
                    priceFormatter.format(prod.price)}
                </span>
              </div>
            </div>
          </a>
        </div>
      </div>
    {/if}
  {/await}
{/if}
